module.exports = __webpack_public_path__ + "img/095_L.f00058ed.png";